import {useEffect, useState} from 'react';
import {useComponentIsMounted} from '@netx/core-components/hooks/useComponentIsMounted';
import {useCategories} from '@netx/core-category/hooks/useCategories';
import {type ICategory} from '../schema';

export type UseCategoryChildrenArguments = {
	id: number;
};

export const useCategoryChildren = ({id}: UseCategoryChildrenArguments) => {
	const _categories = useCategories({ignoreFetch: true});
	const [categories, setCategories] = useState<ICategory[]>([]);
	const [loading, setLoading] = useState(false);

	const {act} = useComponentIsMounted();

	useEffect(() => {
		setLoading(true);
		_categories
			.fetchChildren(id)
			.then((children) => {
				act(() => setCategories(children));
			})
			.catch(() => {
				act(() => setCategories([]));
			})
			.finally(() => {
				act(() => setLoading(false));
			});
	}, [id]);

	return {
		categories,
		loading,
	};
};
